import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { toast } from "sonner";

const CompareContext = createContext(null);
export const useCompare = () => useContext(CompareContext);

const COMPARE_KEY = "shopnow_compare";
export const COMPARE_MAX = 3;

export function CompareProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(COMPARE_KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(COMPARE_KEY, JSON.stringify(items)); }, [items]);

  const inCompare = useCallback((id) => items.some((i) => i.id === id), [items]);

  const toggleCompare = useCallback((product) => {
    setItems((prev) => {
      const exists = prev.find((i) => i.id === product.id);
      if (exists) { toast("Removed from compare"); return prev.filter((i) => i.id !== product.id); }
      if (prev.length >= COMPARE_MAX) { toast.error(`You can compare up to ${COMPARE_MAX} products`); return prev; }
      toast.success("Added to compare");
      return [...prev, product];
    });
  }, []);

  const removeCompare = useCallback((id) => setItems((p) => p.filter((i) => i.id !== id)), []);
  const clearCompare = useCallback(() => setItems([]), []);

  const value = useMemo(() => ({
    items, count: items.length, inCompare, toggleCompare, removeCompare, clearCompare,
  }), [items, inCompare, toggleCompare, removeCompare, clearCompare]);

  return <CompareContext.Provider value={value}>{children}</CompareContext.Provider>;
}
